import React from 'react';
import PdfIcon from '../../images/pdf.svg';

const DocumentsPage = () => {
  return (
    <div className="center-container p-5 d-flex justify-content-around">
      <div className="document-box">
        {documents.map(document => (
          <div className=" d-flex align-items-center mt-4 mb-4 ">
            <img
              alt="promo"
              style={{ width: '50px', height: '50px' }}
              src={PdfIcon}
            ></img>
            <a href={`/files/documents/${document.path}`} download>
              <h5>{document.name}</h5>
            </a>
          </div>
        ))}
      </div>
      <div className="document-box">
        {documents2.map(document => (
          <div className="d-flex align-items-center mt-4 mb-4 ">
            <img
              alt="promo"
              style={{ width: '50px', height: '50px' }}
              src={PdfIcon}
            ></img>
            <a href={`/files/documents/${document.path}`} download>
              <h5>{document.name}</h5>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DocumentsPage;

const documents = [
  {
    path: 'Labour market analysis.pdf',
    name: 'Labour market analysis'
  },
  {
    path: 'Анализа тржишта рада.pdf',
    name: 'Анализа тржишта рада'
  },
  {
    path: 'Biznis+plan+VMC.pdf',
    name: 'Biznis plan VMC'
  },
  {
    path: 'Finansijski+izvestaj+VMC+-+2014.pdf',
    name: 'Finansijski izvestaj VMC 2014.'
  },
  {
    path: 'Finansijski+plan+VMC+-+2015.pdf',
    name: 'Finansijski plan VMC 2015'
  },
  {
    path: 'Godišnji+i+Finansijski+izveštaj+za+2016.+god.pdf',
    name: 'Godišnji i Finansijski izveštaj za 2016. god'
  },
  {
    path: 'Godisnji+izvestaj+VMC+-++2014.pdf',
    name: 'Godisnji izvestaj VMC 2014'
  },
  {
    path: 'Godisnji+izvestaj+VMC+-+2015.pdf',
    name: 'Godisnji izvestaj VMC 2015'
  },
  {
    path: 'Godisnji+plan+rada+-++2016.pdf',
    name: 'Godisnji plan rada 2016'
  },
  {
    path: 'Godisnji+plan+VMC+-++2015.pdf',
    name: 'Godisnji plan VMC 2015'
  }
];

const documents2 = [
  {
    path: 'Izmena+odluke+o+clanarini+VMC+-+2014.pdf',
    name: 'Izmena odluke o clanarini VMC 2014'
  },
  {
    path: 'Odluka+o+clanarini+VMC+-+2012.pdf',
    name: 'Odluka o clanarini VMC 2012'
  },
  {
    path: 'Osnivacki+akt+VMC.pdf',
    name: 'Osnivacki akt VMC'
  },
  {
    path: 'Politika+kvaliteta+VMC+2018.pdf',
    name: 'Politika kvaliteta VMC 2018'
  },
  {
    path: 'Predlog+VMC+Program+rada+i+Finansijski+plan+za+2017.pdf',
    name: 'Predlog VMC Program rada i Finansijski plan za 2017'
  },
  {
    path: 'Statut+VMC.pdf',
    name: 'Statut VMC'
  },
  {
    path: 'Strategija+VMC.pdf',
    name: 'Strategija VMC'
  },
  {
    path: 'Strategija+VMC+pano.pdf',
    name: 'Strategija VMC pano'
  }
];
